const coverModule = {
  // other module props
  id: "7a27a733-05ab-389f-ab8e-9e89ec1993df",
  config: {
    general: {
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        // url: 'https://archive.org/download/BigBuckBunny_124/Content/big_buck_bunny_720p_surround.mp4',
        //url: "https://css-tricks-post-videos.s3.us-east-1.amazonaws.com/708209935.mp4",
        mediaType: "image",
        //mediaType: "video",
      },
      showMedia: true,
      showHeader: true,
      backgroundColor: {
        label: "Grey",
        value: "#cecece",
      },
      ctaType: {
        label: "Button", // or Search
        value: "Button",
      },
      jobCounter: {
        jobs: 59,
        jobsText: "59 jobs",
        showJobCounter: true,
      },
      template: {
        label: "Right Split",
        component: "CoverRightSplit",
      },
    },
    search: {
      placeholderColor: {
        label: "black",
        value: "#000000",
      },
      textColor: {
        label: "black",
        value: "#000000",
      },
      backgroundColor: {
        label: "grey",
        value: "#DEDEDE",
      },
      showIcon: true,
      isTransparent: false,
    },
    ctaButton: {
      text: "View Roles",
      fillStyle: {
        label: "Fill",
        value: "fill",
      },
      corners: {
        label: "Round",
        value: "round",
      },
      link: {
        type: {
          label: "External Link", // external uses url for CtaButton
          value: "external", //or internal, then scrollTarget is used
        },
        url: "https://www.example.com",
        scrollTarget: {
          label: "FAQ",
          value: "16655df8-f1ed-32fd-a850-40a6f10c5021",
        },
        target: {
          label: "New Tab",
          value: "_blank",
        },
      },
      backgroundColor: {
        label: "Black",
        value: "#000000",
      },
      textColor: {
        label: "Green",
        value: "#2bcd41",
      },
    },
    header: {
      isTextInCaps: false,
      text: "Build your future with us.",
      textColor: {
        label: "Black",
        value: "#000000",
      },
    },
    jobCounter: {
      isTextInCaps: false,
      textColor: {
        label: "Black",
        value: "#000000",
      },
    },
  },
};

export default coverModule;
